/* eslint-disable no-console */
import {Gutter} from 'antd/es/grid/row';

export const rowGutter: [Gutter, Gutter] = [16, 8];

export const platformJsonFilter = (array: any[]): any[] => {
  return array.filter((item: any) => {
    return item?.platform ? item?.platform.includes('web') : true;
  });
};
